module.exports = __webpack_public_path__ + "static/hero-background-3c2e47e0187662bec17038fec64b9fc9.png";